import React from 'react';
import SharedHelmet from './Helmet'
const TITLE = 'سياسة الخصوصية';
const DESCRIPTION = 'سياسة الخصوصية';
const KEYWORDS = 'سياسة الخصوصية';
const OG_URL = 'https://do-calculate.com/ar/privacy';
const PrivacyPolicy = () => {
  return (
    <div style={{ direction: 'rtl' }}>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
      <div>
        <h1>سياسة الخصوصية وسرية المعلومات</h1>
        <p>
          نقدر استفساراتكم واهتماماتكم بخصوص خصوصية بياناتكم على الإنترنت. تم إعداد هذه السياسة لتوضيح كيفية تعاملنا مع البيانات الشخصية التي نقوم بتجميعها خلال زيارتكم لموقعنا.
        </p>
        <h2>عملية التصفح</h2>
        <p>
          لم يتم تصميم الموقع لجمع بيانات شخصية من جهاز الكمبيوتر أثناء تصفحك، وسنستخدم فقط البيانات التي تقدموها بمعرفتكم وبموافقتكم.
        </p>
        <h2>عنوان بروتوكول شبكة الإنترنت (IP)</h2>
        <p>
          عند زيارتك لأي موقع على الإنترنت، يُسجل عنوان بروتوكول شبكة الإنترنت (IP) الخاص بك، تاريخ ووقت الزيارة، نوع المتصفح، وعنوان URL للمواقع التي أحيلتم منها إلى موقعنا.
        </p>
        <h2>عمليات المسح على الشبكة</h2>
        <p>
          يُمكن عمليات المسح على الشبكة من جمع بيانات حول آرائكم وتقييمكم للموقع، وتلعب مشاركاتكم دورًا هامًا في تحسين جودة الموقع.
        </p>
        <h2>الروابط إلى مواقع أخرى</h2>
        <p>
          يحتوي موقعنا على روابط إلى مواقع أخرى على الإنترنت، ونود التنويه أننا غير مسؤولين عن جمع بيانات تلك المواقع.
        </p>
        <h2>الإعلانات من الأطراف الثالثة</h2>
        <p>
          نستخدم شركات إعلانات لعرض إعلانات عند زيارتكم للموقع، وهذه الشركات قد تستخدم معلومات حول زياراتكم لتقديم إعلانات تتناسب مع اهتماماتكم.
        </p>
        <h2>إفشاء المعلومات</h2>
        <p>
          سنحتفظ دائمًا بسرية البيانات الشخصية التي نحصل عليها، ولن نفشي تلك المعلومات إلا إذا كان ذلك مطلوبًا بموجب القانون أو للحفاظ على حقوق الملكية الفكرية.
        </p>
        <h2>البيانات الضرورية لتنفيذ المعاملات</h2>
        <p>
          عند الحاجة إلى بيانات خاصة بكم، سنطلبها بموافقتكم، وستساعد هذه البيانات في تنفيذ طلباتكم. لن يتم بيع البيانات أو استخدامها دون موافقتكم، إلا لأغراض إحصائية دون التعرف عليكم.
        </p>
        <h2>التعديلات على سياسة الخصوصية</h2>
        <p>
          نحتفظ بحق تعديل بنود سياسة الخصوصية وسرية المعلومات، وسنقوم بإشعاركم بأي تغييرات.
        </p>
        <h2>الاتصال بنا</h2>
        <p>
          يمكنكم الاتصال بنا عبر البريد الإلكتروني info@do-calculate.com على العنوان المذكور أعلاه.
        </p>
        <h2>في الختام</h2>
        <p>
          نؤكد على أهمية خصوصية بياناتكم، ونأمل أن تتحقق هذه السياسة من تلبية مخاوفكم واهتماماتكم.
        </p>
      </div>
    </div>
  );
};
export default PrivacyPolicy;
